<template>
  <v-footer class="text-center d-flex flex-column ga-2 py-4" color="#194c9b">
    <div class="d-flex ga-3">
      <v-btn
        v-for="icon in icons"
        :key="icon.icon"
        :icon="icon.icon"
        :href="icon.link"
        target="_blank"
        rel="noopener noreferrer"
        density="comfortable"
        variant="text"
      ></v-btn>
    </div>

    <v-divider class="my-2" thickness="2" width="100"></v-divider>

    <div class="text-caption font-weight-regular opacity-60">
      Camino Desierto de los Leones #31, Interior 101. Colonia San Angel,
      Alcaldía Alvaro Obregon, C.P. 01000, en Ciudad de México. tel: 55-5435
      1885
    </div>

    <v-divider></v-divider>

    <div>
      <strong>© {{ new Date().getFullYear() }} — {{ $t("footer") }}</strong>
    </div>
  </v-footer>
</template>

<script>
export default {
  name: "FooterMain",
  data() {
    return {
      icons: [ {icon: "mdi-linkedin", link: 'https://www.linkedin.com/company/itworkers-sc/'}, {icon:"mdi-instagram", link: 'https://www.instagram.com/itw_mexico?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw=='}],
    };
  },
};
</script>
